/**
 * Byte sizes as the design writes them: "2.4 MB", "180 kB".
 *
 * Shared by the source rows on Vstupy and the document cards on Výstupy, which
 * render the same `size` column from two different endpoints.
 *
 * The design pairs the size with a page count ("2.4 MB · 45 stran"); page
 * counts are deliberately not built — see klara_build_plan.md, "Deliberately
 * not built" — because reading them would mean adding pdf-reader outside the
 * development group.
 */
export function formatSize(bytes: number | null) {
  if (!bytes) return null;

  const megabytes = bytes / (1024 * 1024);
  if (megabytes >= 1) return `${megabytes.toFixed(1)} MB`;

  return `${Math.max(1, Math.round(bytes / 1024))} kB`;
}
